<template>
  <div class="device-key-setting-v2">
    <div class="border_title">
      {{ $t('deviceMsg.screenSetting') }}
    </div>
    <div class="device-key-setting-container">
      <div class="device-key-setting-container-left">
        <div
          v-for="(item, index) in screenList"
          :key="index"
          class="screen-key-item"
          :class="index === selectScreenIndex ? 'screen-key-item-active' : ''"
          @click="clickScreen(item, index)"
        >
          <span>{{ item.name }}</span>
        </div>
        <img :src="require('../../assets/img/screenDefault.png')">
      </div>
      <div v-if="selectScreen" class="device-key-setting-container-right">
        <div class="mode">
          <span class="mode-title">{{ selectScreen?.modeInfo?.Desc }}</span>
          <el-select v-model="selectScreen.modeInfo.DefaultValue" @change="changeMode">
            <el-option
              v-for="item in selectScreen.modeInfo.EnumValue"
              :key="item.Value"
              :label="item.Name"
              :value="item.Value"
            />
          </el-select>
        </div>
        <div v-if="selectScreen.modeInfo.DefaultValue == MODE_EMUM.SENCE" v-loading="loading">
          <div v-for="(item, index) in selectScreen.keyList" :key="index" class="device-key-setting-item">
            <span class="device-key-setting-item-title">
              {{ item.name }}
            </span>
            <div class="device-key-setting-item-right">
              <el-popover
                placement="left"
                width="340"
                trigger="click"
                class="el-popover-custom"
                :disabled="!!item.classSku"
              >
                <ul class="opple-ability-ui-com-image-icon-enum_imglist">
                  <li
                    v-for="(img, i) in sceneIconList"
                    :key="i"
                    class="opple-ability-ui-com-image-icon-enum_img"
                    :class="{ active: item.selectIndex === i }"
                    @click="() => handlerIconClick(item, i)"
                  >
                    <img :src="img.Icon">
                  </li>
                </ul>
                <div slot="reference" class="planeBox-icon">
                  <div class="opple-ability-ui-com-image-icon-enum_icon">
                    <img :src="item.Icon">
                    <img src="../../assets/img/edit.png" class="edit">
                  </div>
                </div>
              </el-popover>
              <el-input
                v-model="item.keyName"
                :placeholder="$t('deviceMsg.keyInput')"
                style="width: 200px"
                :disabled="!!item.classSku"
                @input="changeInput(item)"
              />

              <div v-if="!item.ifTT" class="device_add" @click="onAddSence(item)">
                {{ '+' + $t('user.add') }}
              </div>
              <div v-else class="iftt_add">
                <span class="triggerName">{{ item?.ifTT?.triggerName }}</span>
                <div class="iftt">
                  <span>{{ item?.ifTT?.IFT_Name }}</span>
                  <i class="el-icon-edit iftt_edit" @click="editIftt(item)" />
                </div>
                <i class="el-icon-delete iftt_delete" @click="delIftt(item)" />
              </div>
            </div>
          </div>
          <button class="paramSaveBlue paramSave save-btn" :class="isChange ? 'change' : 'gray'" @click="savesubmit">
            {{ $t('deviceMsg.savesubmit') }}
          </button>
        </div>
        <div v-if="selectScreen.modeInfo.DefaultValue == MODE_EMUM.DEVICE" v-loading="loading" class="screen-device">
          <div v-if="showAdd()" class="icon_item" @click="clickAddDevice(item)">
            <img src="../../assets/img/screenAdd.png">
            <span>{{ $t('scene.add') }}</span>
          </div>
          <div v-else class="device_delete" @click="onDeleteDevice">
            {{ $t('deviceMsg.changeBind') }}
          </div>
          <OppleDeviceCard
            v-for="(card, index) in getdeviceCardList()"
            :key="card.VDeviceId"
            :data="card"
            :select-type="selectType"
          />
        </div>
      </div>
    </div>
    <!-- 选择设备弹出 -->
    <template v-if="showDeviceChoose">
      <el-dialog
        :visible="showDeviceChoose"
        class="dialogGroup choose_device"
        :before-close="handleClose"
        top="0"
        append-to-body
      >
        <op-device-choose
          v-if="showDeviceChoose"
          ref="opDeviceChoose"
          class="content"
          :is_group="true"
          :areaid="gpNo"
          :area-tree-type="1"
          :execute-type="2"
          :displaynoarea="true"
          :triggledevice="true"
          :is-ifttt="true"
          :checkeddata="checkeddata"
          :child-category-type="CatParamsStr"
          :only-compare-device="true"
          :class-skus="ClassSkus"
          :device-category-type="SubCatParams"
          @confirm="deviceValueChange"
        />
      </el-dialog>
    </template>

    <OpDialog
      class="triggerIfttt-opDialog"
      :title="$t('deviceMsg.colorCustomize')"
      :visible="showIfttDialog"
      :is-show-btn="false"
      @onClose="closeIfttDialog"
    >
      <IftttCustomSet
        v-if="showIfttDialog"
        ref="EleIftttCustomSet"
        :is-regular-triggle="true"
        :is-triggle="true"
        :is-action="true"
        :is-schedule="true"
        :is-navigate="false"
        :is-init-create-request="true"
        :is-jump-back-page="false"
        :is-need-request-triggger="false"
        :is-custom-back="true"
        :show-entry="1"
        :is-inno-trigger="true"
        :gp-no="device?.Gpno"
        @postEvent="postEvent"
        @back="closeIfttDialog"
      />
    </OpDialog>
  </div>
</template>
<script>
//按键设置组件
import { GetImageList, getSwitchKeyEventList, setSwitchKeyName } from '@/axios/IFttt.js'
import { FindDeviceAndSceneListByCommandValue, GetClassskuList } from '@/axios/IMonitor.js'
import { FindTriggerAbility, FindDeviceAbilityByVDeviceId } from '@/axios/IDevice.js'
import { FindIFtttListByTrigger, Find, Create, Delete } from '@/axios/IFttt.js'
import { alertsuccess, info, alerterror } from '@/assets/js/common.js'
import { jsToUTF8 } from '@/utils/utils.js'
import { SetConfigs } from '@/axios/IDevice.js'
import { getImgUrlState } from '@/utils/utils'
import OppleDeviceCard from '@/components/OppleDeviceCard/index.vue'
import IftttCustomSet from '@/page/ifttt/iftttCustomSet'
import OpDialog from './OpDialog'
const KEYSETTING = {
  smart: 1, //智能灯
  notSmart: 0, //非智能灯
  notSet: 2, //未设置
}
export default {
  components: {
    OppleDeviceCard,
    OpDialog,
    IftttCustomSet,
  },
  props: {
    device: {
      type: Object,
      default: () => ({}),
    },
    GpList: {
      type: Array,
      default: () => [],
    },
    webInnoConfig: {
      type: Array,
      default: () => [],
    },
    ActionList: {
      type: Array,
      default: () => [],
    },
    // 关联设备限制
    relationLimit: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      KeyEventList: [],
      TriggerList: [],
      sceneIconList: [],
      screenList: [], //屏幕
      selectScreenIndex: -1,
      selectScreen: null,
      selectKey: null, //选择的按键
      MODE_EMUM: {
        DEVICE: 0,
        SENCE: 1,
      },
      showDeviceChoose: false, //显示添加弹窗
      checkeddata: [],
      ClassSkus: [], //需要过滤的skus
      CatParamsStr: '',
      SubCatParams: '',
      MaxCount: 0,
      maxDevice: 0,
      loading: false,
      deviceCardList: [],
      selectType: 0,
      showIfttDialog: false, //显示场景弹窗
    }
  },
  computed: {
    //判断是否修改过
    isChange() {
      return (this.selectScreen?.keyList || []).some(item => item.change)
    },
  },
  watch: {
    relationLimit: {
      handler() {
        this.handleLimit()
      },
      deep: true,
    },
  },
  async mounted() {
    this.getImageList()
    this.handleGpList()
    this.handleLimit()
  },
  methods: {
    //获取图片列表
    async getImageList() {
      try {
        const res = await GetImageList()
        this.sceneIconList = (res.Result || []).map(item => ({
          ...item,
          HIcon: `${item.FileUrl}+2`,
          Icon: `${item.FileUrl}+3`,
        }))
      } catch (e) {}
    },
    //获取设备的限制条件
    handleLimit() {
      try {
        if (this.relationLimit) {
          const { Items, LimitType, Max } = this.relationLimit
          if (Items && Array.isArray(Items)) {
            Items.forEach(item => {
              const { Type, Sub } = item
              if (Type === 'Device' && Sub && Array.isArray(Sub) && Sub.length > 0) {
                const { SubCat, Cat, ClassSkus, Max } = Sub[0]
                this.SubCatParams = SubCat.join(',')
                this.CatParamsStr = Cat.join(',')
                this.ClassSkus = ClassSkus.join(',')
                this.deviceMax = Max
              }
            })
          }
          if (LimitType === 'All') {
            this.MaxCount = Max
            this.maxDevice = Max
          } else {
            this.MaxCount = this.deviceMax
            this.maxDevice = this.deviceMax
          }
        }
      } catch (error) {
        console.log('....init error', error)
      }
    },

    /**
     * 获取关联设备列表
     */
    async requestRelationDeviceList() {
      try {
        const hasDeviceList = this.screenList.filter(item => {
          const { screenDeviceGpCondition } = item
          if (screenDeviceGpCondition && screenDeviceGpCondition?.deviceInfo) {
            const { deviceInfo } = screenDeviceGpCondition
            const { DefaultValue } = deviceInfo
            const DefaultValue_ = parseInt(DefaultValue)
            if (DefaultValue_ != 0) {
              return true
            }
            return false
          }
          return false
        })

        this.loading = true
        this.deviceCardList = []
        this.checkeddata = [Object.assign({}, this.device)]
        for (const item of hasDeviceList) {
          // DefaultValue 关联设备的值,不为空才调用,否则接口报错
          if (item?.screenDeviceGpCondition?.deviceInfo?.DefaultValue) {
            const res = await FindDeviceAndSceneListByCommandValue({
              VDeviceId: this.device.VDeviceId,
              CommandValue: item?.screenDeviceGpCondition?.deviceInfo?.DefaultValue,
            })
            if (res.StatusCode == this.$store.state.rightStatusCode) {
              (res.Result || []).forEach(info => {
                info.GpNo = item?.screenDeviceGpCondition?.GpNo
                info.GpKeyId = item?.screenDeviceGpCondition?.GpKeyId
                info.ChildId = 65535
                this.deviceCardList.push(info)
              })
            }
          }
        }
        this.loading = false
        console.log('..........ssss', this.deviceCardList)
      } catch (e) {
        console.log('....获取关联设备列表错误', e)
        this.loading = false
      }
    },
    //获取已配置的按键列表
    async getKeyEventList() {
      try {
        const res = await getSwitchKeyEventList({
          vDeviceId: this.device.VDeviceId,
          type: 1,
        })
        if (res.StatusCode == 0) {
          this.KeyEventList = res?.Result || []
          const list = this.screenList.reduce((pre, next) => {
            if (next.keyList) {
              return pre.concat(next.keyList)
            }
            return []
          }, [])

          this.KeyEventList.forEach(item => {
            //匹配按键 ,复制名字以及icon
            const { KeyEvent, NameId, MessageType } = item
            const find = list.find(info => {
              const { triggerInfo } = info
              if (triggerInfo) {
                const { PhyPosition, MsgID, DefaultValue } = triggerInfo
                return PhyPosition == NameId && MessageType == MsgID && KeyEvent == DefaultValue
              }
              return false
            })
            if (find) {
              find.keyName = item.Name
              find.Icon = item.Icon
              find.HIcon = item.HIcon
            }
          })
        }
      } catch (e) {
        console.log('....获取已配置的按键列表', e)
      }
    },
    handlerIconClick(item, index) {
      item.selectIndex = index
      item.Icon = this.sceneIconList[index].Icon
      item.HIcon = this.sceneIconList[index].HIcon
      item.change = true
    },
    //获取触发器 trigger列表  && 并且填充相应的数据到每一屏的按键
    async getTriggerList() {
      try {
        if (this.TriggerList.length > 0) return
        const res = await FindTriggerAbility({
          VDeviceId: this.device.VDeviceId,
        })
        if (res.StatusCode == 0) {
          this.TriggerList = []
          ;(res.Result?.TriggerList || []).forEach(trigger => {
            ;(trigger.OperationType || []).forEach(operation => {
              this.TriggerList.push({
                ...trigger,
                OperationName: operation.Name,
                OperationValue: operation.Value,
                EnumValue: (trigger.EnumValue || []).map(item => ({
                  ...item,
                })),
              })
            })
          })
          const json = this.TriggerList.reduce((pre, next) => {
            const { Code } = next
            if (!pre[Code]) {
              const { EnumValue, DefaultValue } = next
              if (EnumValue) {
                const find = EnumValue.find(_value => _value.Value == DefaultValue)
                if (find) {
                  next.DefaultValue = find.Value
                }
              }
              pre[Code] = next
            }
            return pre
          }, {})
          this.screenList.forEach(item => {
            const { keyList } = item
            if (keyList) {
              keyList.forEach(res => {
                const { triggerCode } = res
                if (json[triggerCode]) {
                  this.$set(res, 'triggerInfo', json[triggerCode])
                }
              })
            }
          })
          this.getKeyEventList()
          this.getIFtttList()
        }
      } catch (e) {
        console.log('.....获取触发器列表errror', e)
      }
    },
    // 获取所有的绑定的自动化 && 匹配到按键
    async getIFtttList() {
      try {
        this.loading = true
        const res = await FindIFtttListByTrigger({
          vDeviceId: this.device.VDeviceId,
          ShowEntry: 1,
        })
        this.loading = false
        if (res.StatusCode == 0) {
          const Result = res?.Result || []
          const list = this.screenList.reduce((pre, next) => {
            if (next.keyList) {
              return pre.concat(next.keyList)
            }
            return []
          }, [])
          Result.forEach(info => {
            const { TriggerList } = info
            if (TriggerList) {
              TriggerList.forEach(trigg => {
                if (trigg.TriggerList) {
                  trigg.TriggerList.forEach(_tr => {
                    const { ExtraKeyId, KeyId, MsgId, Value1 } = _tr
                    const find = list.find(_list => {
                      const { triggerInfo } = _list
                      return triggerInfo.ExtraKeyId == ExtraKeyId && triggerInfo.KeyID == KeyId && triggerInfo.MsgID == MsgId
                    })
                    if (find) {
                      find.ifTT = info
                      this.$set(find, 'ifTT', info)
                      const { triggerInfo } = find
                      const { EnumValue } = triggerInfo
                      if (EnumValue && Array.isArray(EnumValue)) {
                        const _find = EnumValue.find(_emum => {
                          return _emum.Value == Value1
                        })
                        if (_find) {
                          info.triggerName = _find.Name
                        }
                      }
                    }
                  })
                }
              })
            }
          })
          this.$forceUpdate()
        }
      } catch (e) {
        console.log('.....获取触发器列表errror', e)
      }
    },
    /**
     * 保存
     */
    async savesubmit() {
      try {
        if (!this.isChange) return
        const list = (this.selectScreen?.keyList || [])
          .filter(item => item.change)
          .map(info => {
            const _info = {
              VDeviceId: this.device.VDeviceId,
              Name: info.keyName,
              Icon: info.Icon || '',
              HIcon: info.HIcon || info.Icon || '',
              Type: 1,
              MessageType: info?.triggerInfo?.MsgID ?? '',
              NameId: info?.triggerInfo?.PhyPosition ?? '',
              KeyEvent: info?.triggerInfo?.DefaultValue ?? '',
            }
            return _info
          })
        const req = {
          DeviceSwitchKeyNames: list,
        }
        const res = await setSwitchKeyName(req)
        if (res.StatusCode == 0) {
          alertsuccess(this, res.StatusCode)
          this.selectScreen.keyList.forEach(item => {
            item.change = false
          })
          this.getKeyEventList()
        }
      } catch (error) {
        console.log('保存error', error)
      }
    },
    /**
     * 处理keylist
     */
    handleGpList() {
      try {
        if (this.webInnoConfig && this.webInnoConfig.length > 0 && this.GpList.length > 0) {
          this.screenList = this.webInnoConfig.map((item, index) => {
            const { screenShowGpCondition, relevanceGpCondition, items, screenDeviceGpCondition } = item
            let modeInfo = null //屏的模式
            let modeShowInfo = {} // 屏是否显示信息
            let keyList = []
            if (relevanceGpCondition) {
              //判断屏的显示模式,场景&&设备
              const { GpNo, GpKeyId } = relevanceGpCondition
              modeInfo = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId)
              if (modeInfo) {
                modeInfo.DefaultValue = +modeInfo.DefaultValue
              }
            }
            if (screenDeviceGpCondition) {
              //屏幕关联设备
              const { GpNo, GpKeyId } = screenDeviceGpCondition
              const deviceInfo = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId)
              screenDeviceGpCondition.deviceInfo = deviceInfo
            }
            if (items) {
              keyList = items.map(item => {
                return {
                  ...item,
                  selectIndex: -1,
                  Icon: '',
                  HIcon: '',
                  keyName: '',
                  change: false, //是否修改过按键名称
                }
              })
            }
            return {
              ...item,
              keyList,
              modeInfo,
            }
          })
          if (this.screenList && this.screenList.length > 0) {
            this.selectScreenIndex = 0
            this.selectScreen = this.screenList[0]
            this.requestRelationDeviceList()
            this.getTriggerList()
          }
        }
      } catch (error) {
        console.log('.....errror', error)
      }
    },
    //修改按键名称
    changeInput(item) {
      item.change = true
    },

    clickScreen(item, index) {
      this.selectScreen = item
      this.selectScreenIndex = index
    },

    clickAddDevice(item) {
      this.showDeviceChoose = true
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.showDeviceChoose = false
    },

    /**
     * 选择完设备后弹窗回调
     * @param {*} data 选择的设备
     */
    async deviceValueChange(data) {
      const { screenDeviceGpCondition } = this.selectScreen
      const { GpNo, GpKeyId } = screenDeviceGpCondition
      data.forEach(item => {
        item.Type = 'Device'
        item.GpNo = GpNo
        item.GpKeyId = GpKeyId
      })
      this.showDeviceChoose = false
      const str = this.handleUTF8(data)
      this.bindDeviceOrScene(str, data)
    },
    /**
     * 拼接字符串
     */
    handleUTF8(list) {
      try {
        let str = ''
        let all_length = 0
        list.forEach(item => {
          const { DeviceId, ClassSku, Mac, DeviceName } = item
          if (DeviceId) {
            const linkType = jsToUTF8(0, 1)
            let ProtocolType = ''
            if (item.ProtocolTypeList && Array.isArray(item.ProtocolTypeList) && item.ProtocolTypeList.length > 0) {
              ProtocolType = item.ProtocolTypeList[0]?.Id
              ProtocolType = jsToUTF8(+ProtocolType, 2)
            }
            const id = jsToUTF8(+DeviceId, 4)
            const classSku = jsToUTF8(ClassSku, 4, false, false)
            const mac = jsToUTF8(Mac, 6, false, false)
            let deviceType = ''
            if (item.DeviceTypeList && Array.isArray(item.DeviceTypeList) && item.DeviceTypeList.length > 0) {
              let SubList = item.DeviceTypeList[0]?.SubList
              if (SubList && Array.isArray(SubList) && SubList.length > 0) {
                deviceType = SubList[0]?.Id
                deviceType = jsToUTF8(+deviceType, 4)
              }
            }
            const { hexString, byteLength } = jsToUTF8(DeviceName, 21, true)
            const nameLength = jsToUTF8(+byteLength, 1)
            const name = hexString
            const str1 = linkType + ProtocolType + id + classSku + mac + deviceType + nameLength + name
            str += str1
            all_length += 22 + byteLength
          }
        })
        const all_length_str = jsToUTF8(all_length, 2)
        str = all_length_str + str
        return str
      } catch (error) {
        console.log('......error', error)
      }
    },
    /**
     * 关联设备或场景
     * @param {*} relativeDevices 参数
     */
    async bindDeviceOrScene(str, list) {
      try {
        this.loading = true
        const res = await SetConfigs({
          VDeviceId: this.device.VDeviceId,
          GpNo: this.selectScreen?.screenDeviceGpCondition?.GpNo,
          ConfigItems: [{ Key: this.selectScreen?.screenDeviceGpCondition?.GpKeyId, Values: [str] }],
        })
        this.loading = false
        if (res.StatusCode != this.$store.state.rightStatusCode) {
          alerterror(this, res.StatusCode);
        }
        const { screenDeviceGpCondition } = this.selectScreen
        const { GpNo, GpKeyId } = screenDeviceGpCondition
        this.handleClose()
        const find = this.deviceCardList.findIndex(item => item.GpNo == GpNo && item.GpKeyId == GpKeyId)
        if (find >= 0) {
          this.deviceCardList.splice(find, 1)
        }
        this.deviceCardList = this.deviceCardList.concat(list)
        this.checkeddata = [Object.assign({}, this.device)].concat(list)
      } catch (e) {
        this.loading = false
        this.$message({
          type: 'warning',
          message: e.Message,
        })
      }
    },

    // onSelect(item, ischeck) {
    //   if (ischeck) {
    //     this.deviceDeleteList = [item]
    //   } else {
    //     this.deviceDeleteList = []
    //   }
    // },
    showAdd() {
      if (this.selectScreen) {
        const { screenDeviceGpCondition } = this.selectScreen
        const { GpNo, GpKeyId } = screenDeviceGpCondition
        const find = this.deviceCardList.find(item => item.GpNo == GpNo && item.GpKeyId == GpKeyId)
        return !Boolean(find)
      }
      return true
    },
    //获取每一屏绑定的设备
    getdeviceCardList() {
      if (this.selectScreen) {
        const { screenDeviceGpCondition } = this.selectScreen
        const { GpNo, GpKeyId } = screenDeviceGpCondition
        const find = this.deviceCardList.filter(item => item.GpNo == GpNo && item.GpKeyId == GpKeyId)
        this.checkeddata = [Object.assign({}, this.device)].concat(find)
        return find
      }
      return []
    },
    //换绑设备
    onDeleteDevice() {
      this.showDeviceChoose = true
    },
    //修改每一屏的模式
    async changeMode(value) {
      this.loading = true
      const res = await SetConfigs({
        VDeviceId: this.device.VDeviceId,
        GpNo: this.selectScreen?.relevanceGpCondition?.GpNo,
        ConfigItems: [{ Key: this.selectScreen?.relevanceGpCondition?.GpKeyId, Values: [value] }],
      })
      this.loading = false
      if (res.StatusCode != this.$store.state.rightStatusCode) {
        alerterror(this, res.StatusCode);
      } else {
        // alertsuccess(this, res.StatusCode)
      }
    },
    onAddSence(item) {
      this.showIfttDialog = true
      this.selectKey = item
      this.$nextTick(() => {
        this.$refs.EleIftttCustomSet.deviceOption = [
          {
            VDeviceId: this.device.VDeviceId,
            DeviceName: this.device.DeviceName,
            ChannelId: this.device.ChannelId,
            AreaName: this.device.AreaName,
            ClassSku: this.device.ClassSku,
            ChildId: this.device.ChildId,
            triggle: item?.triggerInfo,
          },
        ]
      })
    },
    closeIfttDialog() {
      this.showIfttDialog = false
    },
    //编辑自动化
    async editIftt(item) {
      const res = await Find({ iftttNo: item?.ifTT?.IFT_ID })
      this.showIfttDialog = true
      this.selectKey = item
      this.$nextTick(() => {
        this.$refs.EleIftttCustomSet.iftttSetParamMake(res.Result)
        this.$refs.EleIftttCustomSet.deviceOption = [
          {
            VDeviceId: this.device.VDeviceId,
            DeviceName: this.device.DeviceName,
            ChannelId: this.device.ChannelId,
            AreaName: this.device.AreaName,
            ClassSku: this.device.ClassSku,
            ChildId: this.device.ChildId,
            triggle: item?.triggerInfo,
          },
        ]
      })
    },
    //删除自动化
    async delIftt(item) {
      this.loading = true
      const res = await Delete({ iftttNo: item?.ifTT?.IFT_ID })
      this.loading = false
      if (res.StatusCode == 0) {
        item.ifTT = null
        this.getIFtttList()
      } else {
        alerterror(this, res.StatusCode)
      }
    },
    //编辑自动化后回调
    async postEvent(item) {
      this.getIFtttList()
      if (this.selectKey && !this.selectKey.keyName) {
        const list = [
          {
            VDeviceId: this.device.VDeviceId,
            Name: item.IFtttName,
            Icon: '',
            HIcon: '',
            Type: 1,
            MessageType: this.selectKey?.triggerInfo?.MsgID ?? '',
            NameId: this.selectKey?.triggerInfo?.PhyPosition ?? '',
            KeyEvent: this.selectKey?.triggerInfo?.DefaultValue ?? '',
          },
        ]
        const req = {
          DeviceSwitchKeyNames: list,
        }
        const res = await setSwitchKeyName(req)
        if (res.StatusCode == 0) {
          this.getKeyEventList()
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.device-key-setting-v2 {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  .device-key-setting-container {
    display: flex;
    width: 100%;
    border: 1px solid #e0e3e6;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    flex-direction: row;

    .device-key-setting-container-left {
      border-right: 3px solid #e0e5ec;
      padding: 32px 0px 31px 0px;
      width: 25%;

      img {
        width: 135px;
        height: 135px;
        margin-left: 50px;
        margin-top: 10px;
      }
      .screen-key-item {
        span {
          font-weight: 400;
          font-size: 14px;
          color: #111111;
          line-height: 40px;
          cursor: pointer;
          margin-left: 59px;
        }
      }
      .screen-key-item-active {
        background-color: #e1eaf7;
        span {
          color: #0046aa;
        }
      }
    }

    .device-key-setting-container-right {
      padding: 40px 17px 61px 40px;
      display: flex;
      flex-direction: column;
      flex: 1;
      .device-key-setting-item {
        width: 100%;
        display: flex;
        flex-direction: row;
        // justify-content: center;
        align-items: center;
        padding: 20px 0px;
        box-sizing: border-box;
        .device-key-setting-item-title {
          font-weight: 400;
          font-size: 14px;
          color: #606266;
          line-height: 17px;
        }
        .device-key-setting-item-right {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: 100px;
          .device_add {
            padding: 9px 10px;
            border: 1px dashed #606266;
            border-radius: 4px;
            color: #606266;
            width: 200px;
            display: flex;
            justify-content: center;
            margin-left: 170px;
          }
          .iftt_add {
            margin-left: 50px;
            flex-direction: row;
            display: flex;
            align-items: center;
            .triggerName {
              width: 100px;
              text-align: right;
            }
            .iftt {
              padding: 9px 10px;
              border: 1px solid #606266;
              border-radius: 4px;
              color: #606266;
              width: 200px;
              display: flex;
              justify-content: space-between;
              margin-left: 20px;
            }
            .iftt_delete {
              margin-left: 20px;
              cursor: pointer;
            }
            .iftt_edit {
              cursor: pointer;
            }
          }
        }
      }
      .save-btn {
        bottom: 20px;
      }
      .mode {
        .mode-title {
          margin-right: 20px;
        }
      }

      .icon_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        img {
          width: 81px;
          height: 81px;
        }

        span {
          font-size: 11px;
          color: #000000;
          margin-top: 5px;
          display: inline-block;
          width: 81px;
          text-align: center;
        }
      }
      .screen-device {
        flex-direction: row;
        display: flex;
        padding-top: 40px;
        position: relative;
      }
      .device_delete {
        position: absolute;
        right: 40px;
        top: 10px;
        padding: 9px 15px;
        border: 1px solid #1b45a4;
        border-radius: 4px;
        color: #1b45a4;
      }
    }
  }
}
.el-popover-custom,
.opple-ability-ui-com-image-icon-enum_img {
  img {
    width: 36px;
    height: 36px;
  }
}

.opple-ability-ui-com-image-icon-enum_icon {
  position: relative;

  .edit {
    position: absolute;
    right: 0;
    top: 0px;
    width: 18px;
    height: 14px;
  }
}

.gray {
  opacity: 0.5;
  border: solid 1px #c6c6c6;
  color: #c6c6c6;
}

.gray:hover {
  cursor: not-allowed;
  border: solid 1px #c6c6c6;
  color: #c6c6c6;
  background: #fff;
}

.change {
  opacity: 1;
}
.device-key-setting-v2 ::v-deep .test {
  width: 1400px;
}
</style>
